import TabsNavContainer from "components/shared/TabsNavContainer";
import Container from "hardcover-ui/components/Container";
import TabLink from "hardcover-ui/components/TabLink";

export default function ProfileLibraryNav({ username }: { username: string }) {
  return (
    <Container size="lg" variant="layout">
      <TabsNavContainer variant="secondary" className="lg:px-2">
        <TabLink
          href={`/@${username}/books/library`}
          size="md"
          variant="secondary"
          greedy
        >
          <>All</>
        </TabLink>
        <TabLink
          href={`/@${username}/books/want-to-read`}
          size="md"
          variant="secondary"
          greedy
        >
          <>Want to Read</>
        </TabLink>
        <TabLink
          href={`/@${username}/books/currently-reading`}
          size="md"
          variant="secondary"
          greedy
        >
          <>Currently Reading</>
        </TabLink>
        <TabLink
          href={`/@${username}/books/read`}
          size="md"
          variant="secondary"
          greedy
        >
          <>Read</>
        </TabLink>
        <TabLink
          href={`/@${username}/books/did-not-finish`}
          size="md"
          variant="secondary"
          greedy
        >
          <>Did Not Finish</>
        </TabLink>
      </TabsNavContainer>
    </Container>
  );
}
